import React from "react";
import {DropdownMenuItem, Icon} from "@reside/ui";

import {UserDropdownMenuProps} from "./types";
import {
  ProfileDropdownMenu,
  ProfileMenuName,
  ProfileMenuNameSection,
} from "./styles";
import {ProfileMenuDropdownTrigger} from "./DropdownButton";
import {SignOut} from "./SignOut";

/** Profile and sign-out via avatar trigger; full name is shown at the top of the menu. */
export const UserProfileAsDropdownMenu = ({user}: UserDropdownMenuProps) => {
  const name = `${user.firstName} ${user.lastName}`;

  return (
    <ProfileDropdownMenu
      trigger={(open: boolean) => (
        <ProfileMenuDropdownTrigger open={open} name={name} />
      )}
    >
      <ProfileMenuNameSection data-test-id="userMenuDisplayName">
        <Icon name="user" size={18} color="darkBlue100" />
        <ProfileMenuName>{name}</ProfileMenuName>
      </ProfileMenuNameSection>
      <DropdownMenuItem
        asLink
        to={`/admin/user/${user.id}/profile`}
        data-test-id="profileLink"
      >
        Profile
      </DropdownMenuItem>

      <SignOut signoutAsDropdownItem />
    </ProfileDropdownMenu>
  );
};
